/** @prettier */
// @flow
import cn from 'classnames';
import React from 'react';

import type { StoreVirtualCurrency } from '#common/flow-types/store';
import type { FiveSymbolLocale } from '#common/utils/locale';

import MinusIcon from '../../../../assets/images/store/icons/minus.svg';
import plusIcon from '../../../../assets/images/store/icons/plus.svg';
import {
  MAX_NUMBER,
  MIN_NUMBER,
} from '../../../../scripts/blocks/store/CustomAmountOnLanding';
import { getCurrencyDisplay } from '../../../../utils/currency-formatter';
import { getStyleForLazyLoad } from '../../../../utils/lazy-load-img';
import { getStoreBuyButtonText } from '../../../../utils/translation';

import { DEFAULT_VC_IMAGE } from '#common/utils/store';

type Props = {
  locale: FiveSymbolLocale,
  isServerSideRender: boolean,
  item: StoreVirtualCurrency,
  price: string,
  handleIncrement?: () => void,
  handleDecrement?: () => void,
  quantity: number,
  handleChange?: () => void,
  handleFocus?: () => void,
  handleBuy?: () => void,
  buttonId: string,
  currency: string,
};

const CustomAmountItem = ({
  locale,
  isServerSideRender,
  item,
  price,
  handleIncrement,
  handleDecrement,
  quantity,
  handleChange,
  handleFocus,
  handleBuy,
  buttonId,
  currency,
}: Props) => {
  const { image_url: img, name } = item;
  return (
    <li className='store__custom-item-wrapper'>
      <div>
        <div
          className='store__custom-item-img lazy'
          data-bg={`url(${img || DEFAULT_VC_IMAGE})`}
          style={getStyleForLazyLoad(
            isServerSideRender,
            img || DEFAULT_VC_IMAGE
          )}
        />
        <div className='store__custom-item-title'>{name}</div>
        <div className='store__custom-item-amount'>
          <button
            id={`${buttonId}-decrement`}
            className={cn('store__custom-item-amount-button', {
              'store__custom-item-amount-button--disabled':
                quantity === MIN_NUMBER,
            })}
            onClick={handleDecrement}
          >
            <div
              className='ui-site-xsolla-logo__img'
              dangerouslySetInnerHTML={{ __html: MinusIcon }} // eslint-disable-line
            />
          </button>
          <input
            className='store__custom-item-amount-input'
            disabled={isServerSideRender ? '' : 'disabled'}
            value={quantity}
            onChange={handleChange}
            onFocus={handleFocus}
            inputMode='numeric'
            type='number'
          />
          <button
            id={`${buttonId}-increment`}
            className={cn('store__custom-item-amount-button', {
              'store__custom-item-amount-button--disabled':
                quantity === MAX_NUMBER,
            })}
            onClick={handleIncrement}
          >
            <div
              className='store__custom-item-amount-button-icon'
              dangerouslySetInnerHTML={{ __html: plusIcon }} // eslint-disable-line
            />
          </button>
        </div>
        <div className='store__btn-block'>
          <button
            id={buttonId}
            className='store__buy-btn store__buy-btn--custom'
            onClick={handleBuy}
          >
            {getStoreBuyButtonText(locale, {
              amount: getCurrencyDisplay(currency, price),
            })}
          </button>
        </div>
      </div>
    </li>
  );
};

export default CustomAmountItem;
